import React, { useContext, useEffect } from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from '@azure/msal-react';
import { Container } from 'react-bootstrap';
import { Navigate, useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/layout';
import ResumeTable from '../../components/resume/users';
import { AppContext } from '../../context/appContext';
import { GET_USER_ROLES } from '../../components/helper/constant';

const { SUPER_USER, DEPARTMENT_HEAD, ACCOUNT_MANAGER, TALENT, TALENT_TEAM } =
  GET_USER_ROLES;

const Resume = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { profile, getRole } = useContext(AppContext);
  const isAuthenticated = useIsAuthenticated();
  const isDevSession =
    process.env.REACT_APP_ENABLE_DEV_LOGIN === 'true' && !!profile;
  const AuthGate = isDevSession ? React.Fragment : AuthenticatedTemplate;
  useEffect(() => {
    if (profile && (isAuthenticated || isDevSession)) {
      const userRole = getRole();
      if (
        ![
          SUPER_USER,
          DEPARTMENT_HEAD,
          TALENT,
          ACCOUNT_MANAGER,
          TALENT_TEAM,
        ].includes(userRole)
      ) {
        navigate('/');
      }
    }
  }, [instance, isAuthenticated, isDevSession, profile]);
  return (
    <>
      {!isDevSession && (
        <UnauthenticatedTemplate>
          <Navigate to="/" />
        </UnauthenticatedTemplate>
      )}
      <AuthGate>
        <Layout>
          <main className={`flex-grow-1 d-flex dashboard`}>
            <Container fluid className="d-flex flex-column p-0">
              <div className="prfList">
                <ResumeTable />
              </div>
            </Container>
          </main>
        </Layout>
      </AuthGate>
    </>
  );
};

export default Resume;
